import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom'
import { Container, Row, Col, Label, Input, Card, CardTitle, CardBody } from "reactstrap";
import { useSelector } from "react-redux";


// RangeSlider
import Nouislider from "nouislider-react";
import "nouislider/distribute/nouislider.css";

//Import Product Images
import ProductList from '../../components/products/ProductList'
import { ProductService } from "../../services/productService";
import { ApiConstants } from "../../common/apiConstants";
import ProductFilter from "../../components/products/ProductFilters";
import { SEARCH_VALUES } from "../../store/search/actionsTypes";



export default function SearchProducts(props) {
    const productService = new ProductService();
    const keyWord = useSelector(state => state.Search.keyWord)
    const [products, setProducts] = useState([]);
    const [localFilters, setLocalFilters] = useState({ sort: ApiConstants.SORT.DEFAULT, min: null, max: null, KeyWord: keyWord, Característica: "", Opciones: [] })

    const getProduct = async () => {
        const lista = await productService.getByKeyWord(keyWord);
        setProducts(lista)
    }

    const newFilters = async (newFilters) => {
        setLocalFilters({ min: parseInt(newFilters.min), max: parseInt(newFilters.max), sort: newFilters.sort })

        //El endpoint de filtros solo funciona si le paso al menos un elemento en "opciones"
        //por eso es necesario validar y llamar un endpoint diferente si se quiere filtrar por texto y no por opciones
        let products = [];

        if (newFilters.opciones.length == 0 || newFilters.categorias.length == 0 && keyWord) {
            //si no tiene filtros pero tiene palabra clave
            newFilters = {
                ...newFilters,
                keyWord: keyWord ? keyWord : "",
                característica: ""
            }
            products = await productService.GetBySpecificFilters(newFilters);

            setProducts(products ?? []);
        } else if (newFilters.opciones.length > 0 || newFilters.categorias.length > 0) {
            //si tiene filtros 
            newFilters = {
                ...newFilters,
                keyWord: keyWord ? keyWord : "",
                característica: ""
            }
            products = await productService.GetBySpecificFilters(newFilters);
            setProducts(products ?? []);
        } else if (newFilters.opciones.length == 0 && !keyWord) {
            //si no tiene ni filtros, ni palabra clave
            getProduct(newFilters);
        }


    }

    useEffect(() => {
        getProduct();
    }, [keyWord])

    return (
        <React.Fragment>
            <div className="page-content">
                <Container>
                    <Row>
                        <Col lg="3">
                            <ProductFilter sendFilters={newFilters} params={{
                                searchType: SEARCH_VALUES,
                                searchValue: keyWord
                            }} />
                        </Col>
                        <Col lg="9">
                            <ProductList products={products || []} />
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );

}